import { Box, Card, Grid2, IconButton, Typography } from "@mui/material";
import PublicIcon from "@mui/icons-material/Public";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import RoomIcon from "@mui/icons-material/Room";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import "./index.css";
import ContactUsSection from "../sections/contact-us/ContactUsSection";
import useScreenSize from "../../hooks/useScreenSize";
import BannerComponent from "../../Components/BannerComponent";

const ContactUs = () => {
  const { isLessThanMd } = useScreenSize();
  return (
    <Box
      className=""
      sx={{
        margin: isLessThanMd ? "0px 20px 50px 20px" : "0px 0px 50px 0px",
      }}
    >
      <Box className="container" sx={{ marginBottom: "20px" }}>
        <BannerComponent
          title="We're Here to Help"
          sectionTitle="Contact Us"
          body="Supporting you with the financial tools to thrive."
        />
        <Grid2 container spacing={2} className="section-divide">
          <Grid2 size={{ xs: 12 }}>
            <Card
              sx={{
                display: "flex",
                flexDirection: isLessThanMd ? "column" : "row",
                justifyContent: "space-evenly",
                padding: "40px 0",
                gap: isLessThanMd ? 5 : 0,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1.5,
                  flex: 1,
                }}
              >
                <IconButton className="contactUs-section1-icon">
                  <DraftsOutlinedIcon />
                </IconButton>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: "22px",
                    fontWeight: 700,
                    marginBottom: 0,
                    marginTop: "10px",
                  }}
                >
                  Our Email Here
                </Typography>
                <Box>
                  <Typography
                    sx={{
                      color: "#7a8595",
                      fontSize: "15px",
                      lineHeight: "30px",
                      marginBottom: "0",
                    }}
                  >
                    <a
                      style={{
                        color: "#7a8595",
                      }}
                      href="mailto:tresormicro@gmail.com"
                    >
                      tresormicro@gmail.com
                    </a>
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1.5,
                  flex: 1,
                }}
              >
                <IconButton className="contactUs-section1-icon">
                  <PublicIcon />
                </IconButton>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: "22px",
                    fontWeight: 700,
                    marginBottom: 0,
                    marginTop: "10px",
                  }}
                >
                  Visit Our Site
                </Typography>
                <Box>
                  <Typography
                    sx={{
                      color: "#7a8595",
                      fontSize: "15px",
                      lineHeight: "30px",
                      marginBottom: "0",
                      textAlign: "center",
                    }}
                  >
                    Plot No 158, New Defence Colony Opposite Metro Pillar No
                    874, Muradnagar Ghaziabad Uttar Pradesh 201206
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",

                  alignItems: "center",
                  gap: 1.5,
                  flex: 1,
                }}
              >
                <IconButton className="contactUs-section1-icon">
                  <HeadsetMicOutlinedIcon />
                </IconButton>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: "22px",
                    fontWeight: 700,
                    marginBottom: 0,
                    marginTop: "10px",
                  }}
                >
                  Call To Us
                </Typography>
                <Box>
                  <Typography
                    sx={{
                      color: "#7a8595",
                      fontSize: "15px",
                      lineHeight: "30px",
                      marginBottom: "0",
                    }}
                  >
                    0123-2359809
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                marginTop: 0,
                marginBottom: "30px",
                paddingBottom: "30px",
                borderBottom: "1px solid #cccccc",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: "22px",
                  fontWeight: 600,
                  marginBlock: "20px",
                  textAlign: isLessThanMd ? "center" : "left",
                }}
              >
                Contact Info:
              </Typography>
              <Typography
                sx={{
                  color: "#7a9595",
                  fontSize: "15px",
                  fontWeight: 400,
                  lineHeight: "30px",
                  marginBottom: 0,
                  textAlign: isLessThanMd ? "center" : "left",
                }}
              >
                If you have any questions, inquiries, or would like to get in
                touch with me, feel free to reach out through the contact
                details below. I'm happy to connect and look forward to hearing
                from you.
              </Typography>
            </Box>
            <Box>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td style={{ padding: "8px", verticalAlign: "text-top" }}>
                      <span
                        style={{ display: "inline-flex", alignItems: "center" }}
                      >
                        <IconButton
                          disabled
                          sx={{ marginRight: "20px", padding: 0 }}
                        >
                          <RoomIcon sx={{ height: "18px" }} />
                        </IconButton>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#595959",
                          }}
                        >
                          Address:
                        </Typography>
                      </span>
                    </td>
                    <td style={{ padding: "8px", textAlign: "right" }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#595959",
                        }}
                      >
                        Opposite Metro Pillar No 874, Muradnagar Ghaziabad Uttar
                        Pradesh 201206
                      </Typography>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "8px", verticalAlign: "middle" }}>
                      <span
                        style={{ display: "inline-flex", alignItems: "center" }}
                      >
                        <IconButton
                          disabled
                          sx={{ marginRight: "20px", padding: 0 }}
                        >
                          <LocalPhoneIcon sx={{ height: "18px" }} />
                        </IconButton>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#595959",
                          }}
                        >
                          Contact:
                        </Typography>
                      </span>
                    </td>
                    <td style={{ padding: "8px", textAlign: "right" }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#595959",
                        }}
                      >
                        0123-2359809
                      </Typography>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "8px", verticalAlign: "middle" }}>
                      <span
                        style={{ display: "inline-flex", alignItems: "center" }}
                      >
                        <IconButton
                          disabled
                          sx={{ marginRight: "20px", padding: 0 }}
                        >
                          <EmailIcon sx={{ height: "18px" }} />
                        </IconButton>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#595959",
                          }}
                        >
                          Email:
                        </Typography>
                      </span>
                    </td>
                    <td style={{ padding: "8px", textAlign: "right" }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#595959",
                        }}
                      >
                        <a
                          style={{
                            color: "#595959",
                          }}
                          href="mailto:tresormicro@gmail.com"
                        >
                          tresormicro@gmail.com
                        </a>
                      </Typography>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1177.2627665063185!2d77.50119506966064!3d28.760410098474715!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cf59cba4fa101%3A0xfe8c76070dd092a0!2sAv%20Poultry%20Shakti%20Feed!5e1!3m2!1sen!2sin!4v1777534921114!5m2!1sen!2sin"
              style={{
                border: 0,
                width: "100%",
                height: isLessThanMd ? "250px" : "100%",
                maxHeight: "400px",
              }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </Grid2>
        </Grid2>
      </Box>
      <ContactUsSection />
    </Box>
  );
};

export default ContactUs;

{
  /*<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d485.10522303311876!2d77.50598617563955!3d28.76104583728176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cf440dd4f3901%3A0xa8bcc40f976be2d8!2sTRISHIV%20TECHNOLOGY%20NIDHI%20LIMITED!5e0!3m2!1sen!2sin!4v1731005438196!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>*/
}
